
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 21 19","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.991 4.084l-1.41 1.41 2.58 2.59H6.991v2h10.17l-2.58 2.58 1.41 1.42 5-5-5-5zm-13-2h8v-2h-8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2h-8v-14z"}})])
          )
        }
      }
    